import styles from './Contact.module.css';
import Header from "../components/layout/header";
import Footer from "../components/layout/footer";
import Banner from '../components/common/banner';
import Breadcrumb from '../components/common/breadcrumb';
import Register from '../components/common/register';

function ContactPage() {
  return (
    <>
      <Header />

      <Banner imageSrc="/images/contact.jpg" title="Liên hệ" />

      <div className={`${styles.contact} container`}>
        <Breadcrumb />
        <div>
          <div className={styles.contact_info}>
            <h2>Thông tin liên hệ</h2>

            {/* Hotline */}
            <div className={styles.contact_hotline}>
              <img src="/icons/hotline_green.svg" alt="Hotline" />
              <div className={styles.hotline_detail}>
                <h3>Hotline tư vấn</h3>
                <p>02103.993.995 - 0984.498.256 (Mrs.Hồng)</p>
              </div>
            </div>

            {/* Email */}
            <div className={styles.contact_email}>
              <img src="/icons/email_green.svg" alt="Email" />
              <div className={styles.email_detail}>
                <h3>Email</h3>
                <p>newlifecompany.pt@gmail.com - ptth061283@gmail.com</p>
              </div>
            </div>

            {/* Địa chỉ */}
            <div className={styles.contact_address}>
              <img src="/icons/address_green.svg" alt="Address" />
              <div className={styles.address_detail}>
                <h3>Địa chỉ</h3>
                <div className={styles.address_item}>
                  <h4>Trụ sở chính</h4>
                  <p>Số 9, 58C phố Xuân Nương, 6C phường Nông Trang, thành phố Việt Trì, tỉnh Phú Thọ</p>
                </div>
                <div className={styles.address_item}>
                  <h4>Chi nhánh Hàn Quốc</h4>
                  <p>Tầng 4, số 32 Bangulaen-ro, Mapo-gu, Seoul, Hàn Quốc</p>
                </div>
                <div className={styles.address_item}>
                  <h4>Chi nhánh Thái Bình</h4>
                  <p>Quang Trung, Hưng Hà, Thái Bình</p>
                </div>
                <div className={styles.address_item}>
                  <h4>Chi nhánh Vĩnh Phúc</h4>
                  <p>Đê Hến, Bá Hiến, Bình Xuyên, Vĩnh Phúc</p>
                </div>
              </div>
            </div>

            {/* Fanpage */}
            <div className={styles.contact_facebook}>
              <img src="/icons/facebook_green.svg" alt="Email" />
              <div className={styles.facebook_detail}>
                <h3>Fanpage</h3>
                <p>
                  <a href="https://www.facebook.com/phungthuhong1983" target='_blank' rel="noopener noreferrer">
                    Trung tâm Du học Hàn Quốc New Life
                  </a>
                </p>
              </div>
            </div>
          </div>

          <Register />
        </div>
      </div>

      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3716.4167433065268!2d105.3701888510124!3d21.334051126836194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3134929c517189c5%3A0xf1d55bd2f63934fa!2zOSBYdcOibiBOxrDGoW5nLCBOw7RuZyBUcmFuZywgVmnhu4d0IFRyw6wsIFBow7ogVGjhu40sIFZp4buHdCBOYW0!5e0!3m2!1svi!2s!4v1768726116412!5m2!1svi!2s"
          width="100%"
          height="450"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Bản đồ vị trí Trung tâm Du học Hàn Quốc New Life"
        />
      </div>

      <Footer />
    </>
  );
}

export default ContactPage;